interface CSVTableProps {
  data: string[][]
  fileName?: string
}

export const generateCSVTable = (props: CSVTableProps) => {
  const { data, fileName } = props

  const csvContent = data.map((row) => row.map(escapeCSV).join(',')).join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })

  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.setAttribute('href', url)
  link.setAttribute('download', fileName || 'transaction_report.csv')

  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

const escapeCSV = (value: unknown) => {
  if (value === null || value === undefined) {
    return ''
  }

  const str = String(value)

  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }

  return str
}
